import { useEffect, useState } from "react";
import api from "@/lib/api";

// Modulinio lygio cache — facets užkraunami vieną kartą per sesiją,
// visi komponentai (Header, Home, Catalog) dalinasi tuo pačiu rezultatu.
let cached = null;
let inflight = null;

export default function useFacets() {
  const [facets, setFacets] = useState(cached || { brands: [], materials: [], services: [] });

  useEffect(() => {
    if (cached) return;
    if (!inflight) {
      inflight = api.get("/products-facets")
        .then((r) => { cached = r.data; return cached; })
        .catch(() => ({ brands: [], materials: [], services: [] }));
    }
    let alive = true;
    inflight.then((data) => { if (alive) setFacets(data); });
    return () => { alive = false; };
  }, []);

  return facets;
}
